// @flow
import * as React from 'react';

import get from 'lodash/get';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { superpathjoin } from 'superpathjoin';

import { selectPricingInfos } from '@gandi/billing';
import {
  updateCartProduct,
  removeCartProduct,
  selectCartIsWorking,
} from '@gandi/cart';
import { notifyDanger } from '@gandi/notifications';
import { localeSelector } from '@gandi/translate';

import { serversResource } from '../../../../modules/cloud/resources/servers';
import { selectAdminURL } from '../../../../modules/config';
import type { FullState, WithRouterProps, Dispatch } from '../../../../types';
import { withQuotations } from '../../../modules/quotations';
import type { PresenterProps as ParentProps } from '../../Presenter';

import Presenter, {
  type PresenterDispatchProps,
  type PresenterOwnProps,
  type PresenterStateProps,
} from './Presenter';

const mapStateToProps = (
  state: FullState,
  ownProps: PresenterOwnProps & ParentProps & WithRouterProps<>,
): PresenterStateProps => {
  // $FlowIgnore[incompatible-call]
  const pricingInfos = selectPricingInfos(state);

  const adminUrl = selectAdminURL(state);

  const adminCloudURL = superpathjoin(
    adminUrl,
    'cloud',
    pricingInfos.sharingId,
    'servers',
  );

  const fetchParams = {
    sharing_id: pricingInfos.sharingId,
  };
  const label = serversResource.computeLabel(
    serversResource.options.postPath,
    fetchParams,
  );

  return {
    adminCloudURL,
    cartIsWorking: selectCartIsWorking(state),
    // $FlowFixMe[prop-missing]
    fetchParams,
    isCreatingServer: serversResource.selectIsPosting(state, label),
    label,
    locale: localeSelector(state),
    server: get(ownProps.product, 'payload.server'),
  };
};

const mapDispatchToProps = (dispatch: Dispatch): PresenterDispatchProps => ({
  // $FlowIgnore[prop-missing]
  createServer: (...args: any) => dispatch(serversResource.post(...args)),
  updateCartProduct: (...args) => dispatch(updateCartProduct(...args)),
  removeCartProduct: (...args) => dispatch(removeCartProduct(...args)),
  notifyDanger: (...args) => dispatch(notifyDanger(...args)),
});

export default (compose(
  withQuotations,
  connect(mapStateToProps, mapDispatchToProps),
)(Presenter): React.ComponentType<{ ... }>);
